<app-question-card>
  <p question>Does the home have a basement?</p>
  <div class="form-field" input-options>
    <div class="radio-option-circle">
      <input type="radio" id="yes" name="basement" [value]="true" [(ngModel)]="basementPresent" />
      <label for="yes" class="basement-yes">
        <span class="label">Yes</span>
        <div class="w-100 mt-3" *ngIf="basementPresent">
          <p class="text-size-18 fw-500 mb-3">How much is finished?</p>
          <div class="finish-percs">
            <div class="radio-fill" *ngFor="let perc of finishedPercentages">
              <input type="radio" [id]="perc" name="basement-percentage" [value]="perc" [(ngModel)]="finishedPercentageSelected" />
              <label [for]="perc"> {{perc}}% </label>
            </div>
          </div>
        </div>
      </label>
    </div>
    <div class="radio-option-circle">
      <input type="radio" id="no" name="basement" [value]="false" [(ngModel)]="basementPresent" />
      <label for="no">No</label>
    </div>
  </div>
  <p class="chat-answer" answer>{{ basementPresent ? "Yes" : "No" }}</p>
  <button class="w-100" footer [disabled]="!nextEnabled" (click)="next()">Continue</button>
</app-question-card>
